import * as type from "../../types/API/bomRawMaterials";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getBOMRawMaterialsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BOM_RAW_MATERIALS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_BOM_RAW_MATERIALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_BOM_RAW_MATERIALS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addBOMRawMaterialsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_BOM_RAW_MATERIALS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_BOM_RAW_MATERIALS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_BOM_RAW_MATERIALS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateBOMRawMaterialsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_BOM_RAW_MATERIALS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.UPDATE_BOM_RAW_MATERIALS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.UPDATE_BOM_RAW_MATERIALS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteBOMRawMaterialsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_BOM_RAW_MATERIALS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_BOM_RAW_MATERIALS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_BOM_RAW_MATERIALS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const issueRawMaterialReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ISSUE_RAW_MATERIAL:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ISSUE_RAW_MATERIAL_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData?.message,
      };
    case type.ISSUE_RAW_MATERIAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const linkBomReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.LINK_BOM:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.LINK_BOM_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData?.message,
      };
    case type.LINK_BOM_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const unlinkBomReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UNLINK_BOM:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.UNLINK_BOM_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData?.message,
      };
    case type.UNLINK_BOM_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};